import MenuItem from '@mui/material/MenuItem'
import { SxProps } from '@mui/material/styles'
import { Link } from 'react-router'

const menuItemStyles: SxProps = {
  wordWrap: 'break-word',
  whiteSpace: 'normal',
}

type SplitButtonMenuItemProps = {
  id: string
  children: React.ReactNode
  disabled?: boolean
  to?: string
  onClick?: (event: React.MouseEvent) => void
  selected?: boolean
  color?: string
}

const SplitButtonMenuItem: React.FC<SplitButtonMenuItemProps> = ({
  id,
  children,
  disabled,
  to,
  onClick,
  selected,
  color,
}) => {
  return !!to ? (
    <MenuItem
      sx={{ ...menuItemStyles, color }}
      id={id}
      component={Link}
      to={to!}
      disabled={disabled}
      selected={selected}>
      {children}
    </MenuItem>
  ) : (
    <MenuItem
      sx={{ ...menuItemStyles, color }}
      id={id}
      onClick={onClick!}
      disabled={disabled}
      selected={selected}>
      {children}
    </MenuItem>
  )
}

export default SplitButtonMenuItem
